import { Tooltip } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
var colorItem = {
  type: 'input',
  tooltip: 'Text Color',
  inputType: 'color',
  onInput: function onInput(editor, event) {
    return editor.chain().focus().setColor(event.currentTarget.value).run();
  },
  getValue: function getValue(editor) {
    return editor.getAttributes('textStyle').color;
  }
};
export var ColorMenu = function ColorMenu(_ref) {
  var editor = _ref.editor,
      labels = _ref.labels;
  return /*#__PURE__*/_jsx(Tooltip, {
    title: labels.textColor,
    children: /*#__PURE__*/_jsx("input", {
      style: {
        width: 24,
        height: 24
      },
      type: colorItem.inputType,
      onInput: function onInput(event) {
        return colorItem.onInput(editor, event);
      },
      value: colorItem.getValue(editor),
      "data-testid": "setColor"
    })
  });
};